import LoadingAnimation from '../loading-animation/loading-animation';
import NewsAndEventsCard from '../news-and-media-card/news-and-media-card';
import ProductCard from '../product-card/product-card';
import './content-grid.scss';

const ContentGrid = ({ className, data }) => {
	if (data.length <= 0) {
		return <LoadingAnimation type={`${className}`} />;
	}
	return (
		<div className={`${className}__grid`}>
			{data.map((post) => {
				if (className === 'products') {
					return (
						<ProductCard
							key={post.id || post.permalink}
							title={post.title}
							image_URL={post.image_URL}
							post_date={post.post_date}
							permalink={post.permalink}
							theme={post.theme}
						/>
					);
				} else if (className === 'news-and-events') {
					return (
						<NewsAndEventsCard
							key={post.id || post.permalink}
							title={post.title}
							image_URL={post.image_URL}
							post_date={post.post_date}
							permalink={post.permalink}
							excerpt={post.excerpt}
							media={post.media}
							event_date={post.event_date}
						/>
					);
				}
			})}
		</div>
	);
};

export default ContentGrid;
